import styled from 'styled-components';

export const LegalTextStyles = styled.div`
  .legal-text {
    h1 {
      font-weight: 600;
      margin: 20px 0;
      font-size: 20px;
      line-height: 24px;
      text-transform: uppercase;
    }
    &.footer {
      margin-top: 20px;
    }
    h2 {
      font-weight: 600;
      font-size: 16px;
      line-height: 18px;
      margin-bottom: 24px;
    }
    p {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 24px;
      text-align: justify;
      text-justify: auto;
      &:last-child {
        margin-bottom: 0px;
      }
    }
    ol {
      list-style: auto;
      font-weight: 600;
      font-size: 16px;
      line-height: 18px;
    }
    ul {
      li {
        margin-bottom: 24px;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 24px;
        text-align: justify;
        text-justify: auto;
      }
    }
  }
`;
